import React from "react";
import { Badge } from "react-bootstrap";
import PropTypes from "prop-types";

const LetterHeader = ({
  branchData = {},
  useOldAddress = false,
  badgeText = "OFFICIAL RECEIPT",
  badgeBg = "primary",
  showBadge = true,
  paperSize = "A4", // "A4" or "A5"
  className = "",
}) => {
  const logoUrl = branchData?.logoUrl || "";
  const oldLogoUrl = branchData?.oldLogoUrl || "";
  const activeLogo = useOldAddress ? oldLogoUrl : logoUrl;

  const contact = branchData?.contactNo || "Contact Number";
  const selectedBranchName = useOldAddress
    ? branchData?.oldTradeName
    : branchData?.TradeName;

  const selectedAddress = useOldAddress
    ? branchData?.oldAddress
    : branchData?.address;

  const isA5 = paperSize.toUpperCase() === "A5";
  const logoWidth = isA5 ? "70px" : "90px";
  const logoMaxHeight = isA5 ? "55px" : "70px";
  const titleFontSize = isA5 ? "1.1rem" : "1.3rem";

  // Build full address string cleanly
  const fullAddress = [
    selectedAddress?.second_line,
    selectedAddress?.third_line,
    selectedAddress?.fourth_line,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div
      className={`d-flex align-items-start gap-3 mb-3 letter-header ${className}`}
      style={{ width: "100%", textAlign: "left" }}
    >
      {/* Fixed-Width Left Logo */}
      <div
        className="flex-shrink-0 text-start"
        style={{ width: logoWidth, minWidth: logoWidth }}
      >
        {activeLogo ? (
          <img
            src={activeLogo}
            alt="Institute Logo"
            className="img-fluid d-block"
            style={{
              maxHeight: logoMaxHeight,
              width: "100%",
              objectFit: "contain",
              objectPosition: "left top",
            }}
          />
        ) : (
          <div
            className="p-1 bg-light rounded text-muted text-center fw-semibold d-flex align-items-center justify-content-center border"
            style={{ height: logoMaxHeight, fontSize: "0.75rem" }}
          >
            LOGO
          </div>
        )}
      </div>

    {/* Main Header Content */}
<div className="flex-grow-1 min-w-0">
  {/* Title & Badge Row */}
  <div className="d-flex align-items-center justify-content-between position-relative">
    
    {/* Centered Title */}
    <h4
      className="fw-bold mb-0 text-dark flex-grow-1 text-center"
      style={{
        fontSize: titleFontSize,
        letterSpacing: "-0.02em",
        lineHeight: 1.2,
        textAlign: "center",
      }}
    >
      {selectedBranchName || "Institute Name"}
    </h4>

    {/* Badge positioned independently so it doesn't push the title off-center */}
    {showBadge && badgeText && (
      <Badge
        bg={badgeBg}
        className={`px-3 py-2 fw-normal text-uppercase flex-shrink-0 ms-2 ${
          isA5 ? "small" : ""
        }`}
        style={{ whiteSpace: "nowrap" }}
      >
        {badgeText}
      </Badge>
    )}
  </div>

        {/* Address Lines (Ensures clean text wrapping without centering line 2) */}
        {fullAddress && (
          <div
            className="text-secondary small mt-1"
            style={{
              fontSize: isA5 ? "0.75rem" : "0.825rem",
              lineHeight: 1.35,
              textAlign: "left",
              wordBreak: "break-word",
            }}
          >
            {fullAddress}
          </div>
        )}

        {/* Contact Information (Kept in a left-aligned inline flow) */}
        <div
          className="text-muted small mt-1"
          style={{
            fontSize: isA5 ? "0.725rem" : "0.8rem",
            lineHeight: 1.35,
            textAlign: "left",
          }}
        >
          <span className="me-2" style={{ display: "inline-block" }}>
            <strong>Phone:</strong> {contact}
          </span>
          {branchData?.email && (
            <span className="me-2" style={{ display: "inline-block" }}>
              <span className="me-2 opacity-50">|</span>
              <strong>Email:</strong> {branchData.email}
            </span>
          )}
          {branchData?.website && (
            <span style={{ display: "inline-block" }}>
              <span className="me-2 opacity-50">|</span>
              <strong>Web:</strong> {branchData.website}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

LetterHeader.propTypes = {
  branchData: PropTypes.object,
  useOldAddress: PropTypes.bool,
  badgeText: PropTypes.string,
  badgeBg: PropTypes.string,
  showBadge: PropTypes.bool,
  paperSize: PropTypes.oneOf(["A4", "A5"]),
  className: PropTypes.string,
};

export default LetterHeader;